import React from "react";

import ModalV1 from "../../../../resuable-ui/modal-v1/index";
import { DeleteCartItemContent } from "../../../../resuable-ui/modals-mobile/delete-cart-item-content";

import { IDeleteCartItem } from "../../../../../models";

interface IDeleteContent {
  show: boolean;
  item: {
    name: string;
    id: string;
    refCartId: string;
  };
  onClose: (arg: boolean) => void;
  handleDelete: (arg: IDeleteCartItem) => void;
}

export const DeleteModalContent = ({
  show,
  item,
  onClose,
  handleDelete,
}: IDeleteContent) => {
  return (
    <ModalV1
      classes={{ content: 'z-[500]' }}
      show={show}
      onClose={() => onClose(false)}
      headerAction={<div className="text-base font-semibold text-gray-900">Remove Item</div>}
    >
      <DeleteCartItemContent item={item} onClose={() => onClose(false)} handleDelete={handleDelete} />
    </ModalV1>  );
};